"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GOAL_PAST_DATE_COPY = void 0;
exports.goalTargetDateInPast = goalTargetDateInPast;
/**
 * A goal's target date may not start in the past (BEN-141 FP-044, the client half).
 *
 * Both forms and the server accepted 2020-01-01 on create, and the goal began life
 * as "Overdue · $3,000/mo needed". Refused when the date is set or changed; an
 * existing goal that has since gone overdue still saves untouched. `today` is the
 * client's LOCAL date (a UTC date is a day off in the Americas).
 */
exports.GOAL_PAST_DATE_COPY = "Pick today or a later date. A goal can't start overdue.";
function goalTargetDateInPast(date, today, saved) {
    return (/^\d{4}-\d{2}-\d{2}$/.test(date) && date < today && date !== (saved ?? null));
}
//# sourceMappingURL=goalDateCopy.js.map